// import { SyncClient } from 'twilio-sync';
var { SyncClient } = require('twilio-sync');

const getTwilioSyncClient = async (token) => {
  const client = new SyncClient(token);
  return client;
};

export default getTwilioSyncClient;
